import { MODULE } from "./labelFilter.actionTypes";

export const isFetchingLabels = (state) =>
  state.getIn([MODULE, "isFetchingLabels"]);

export const getLabels = (state) => state.getIn([MODULE, "labels"]);

export const getSelectedLabels = (state) =>
  state.getIn([MODULE, "selectedLabels"]);
